import { render, staticRenderFns } from "./side-bar.vue?vue&type=template&id=8c294494&scoped=true"
import script from "./side-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./side-bar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./side-bar.vue?vue&type=style&index=0&id=8c294494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c294494",
  null
  
)

export default component.exports